import React from 'react';
import { useMsal } from '@azure/msal-react';

/**
 * Header du portail IT
 * Affiche le logo, le titre et les infos de l'utilisateur connecté
 */
const Header: React.FC = () => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <header className="bg-white border-b border-ms-gray-200 h-14 flex items-center justify-between px-6 fixed top-0 left-0 right-0 z-50">
      <div className="flex items-center gap-3">
        {/* Icône IT Portal */}
        <div className="w-8 h-8 bg-ms-blue rounded flex items-center justify-center">
          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
            <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
          </svg>
        </div>
        <h1 className="text-lg font-semibold text-ms-gray-800">IT Portal</h1>
      </div>

      {account && (
        <div className="flex items-center gap-4">
          <div className="text-right">
            <p className="text-sm font-medium text-ms-gray-800">{account.name}</p>
            <p className="text-xs text-ms-gray-500">{account.username}</p>
          </div>
          <button
            onClick={handleLogout}
            className="text-sm text-ms-gray-500 hover:text-ms-gray-800 transition-colors px-3 py-1.5 rounded hover:bg-ms-gray-100"
          >
            Déconnexion
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
